import Column from '@components/Column';
import styled from '@emotion/styled';

import NewsContents from './NewsContents';
import OfficialChannels from './OfficialChannels';
import OrderContents from './OrderContents';

function SidebarContents() {
    return (
        <Container fullWidth >
            <OrderContents/>
            <NewsContents/>
            <OfficialChannels/>
        </Container>
    );
}

const Container = styled(Column)`
    flex: 1;
    overflow: auto;
`;

export default SidebarContents;
